const priceParser = (price: string) => {
  let priceParsed = price;
  if (price.length > 1) {
    priceParsed = `${price.substring(0, price.length - 2)}.${price.substring(price.length - 2)}`;
  }
  return parseFloat(priceParsed);
};
export default priceParser;
